import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import moment from "moment";
import useHttpHook from "../../Hooks/HttpHook";
import { OrderLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import Input from "../UiElement/FormElement/Input";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const fieldProps = {
  WrapperClass: "",
  CustomFormGroupCls: "event-orders-field",
  InputClassName: "event-orders-input",
  LabelCls: "event-orders-label",
};

const OrderFilter = ({ handleFilterInput }) => {
  const [loading, , error] = useHttpHook();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const onSubmit = useCallback(
    async (data) => {
      const payload = {
        ...data,
        maxPrice: data?.maxPrice ? parseInt(data.maxPrice, 10) : data.maxPrice,
        minPrice: data?.minPrice ? parseInt(data.minPrice, 10) : data.minPrice,
        startDate: data?.startDate
          ? moment(data.startDate, "YYYY-MM-DD").startOf("day").toISOString()
          : data.startDate,
        endDate: data?.endDate
          ? moment(data.endDate, "YYYY-MM-DD").endOf("day").toISOString()
          : data.endDate,
      };

      if (payload.endDate && !payload.startDate) {
        alert("Please select start Date.");
        return;
      }

      if (
        payload.startDate &&
        payload.endDate &&
        payload.startDate > payload.endDate
      ) {
        alert("Start Data should be less than end Date");
        return;
      }

      handleFilterInput(payload);
    },
    [handleFilterInput]
  );

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <form
        className="event-orders-filters"
        id="order-filter"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="event-orders-filters-row">
          <Input
            {...fieldProps}
            defValue=""
            element="text"
            Label={OrderLanguage.FilterForm.FormLabals.event.label}
            FieldName="eTitle"
            placeholder={OrderLanguage.FilterForm.FormLabals.event.placeHolder}
            Register={register}
            Errors={errors}
          />
          <Input
            {...fieldProps}
            defValue=""
            element="date"
            Label={OrderLanguage.FilterForm.FormLabals.startDate.label}
            FieldName="startDate"
            filter="true"
            pickerIcon
            Register={register}
            Errors={errors}
          />
          <Input
            {...fieldProps}
            defValue=""
            element="date"
            Label={OrderLanguage.FilterForm.FormLabals.endDate.label}
            FieldName="endDate"
            filter="true"
            pickerIcon
            Register={register}
            Errors={errors}
          />
        </div>

        <div className="event-orders-filters-row event-orders-filters-row--search">
          <Input
            {...fieldProps}
            defValue=""
            element="text"
            Label={OrderLanguage.FilterForm.FormLabals.registered.label}
            FieldName="rName"
            placeholder={OrderLanguage.FilterForm.FormLabals.registered.placeHolder}
            Register={register}
            Errors={errors}
          />
          <Input
            {...fieldProps}
            defValue=""
            element="number"
            Label={OrderLanguage.FilterForm.FormLabals.minPrice.label}
            placeholder={OrderLanguage.FilterForm.FormLabals.minPrice.placeHolder}
            FieldName="minPrice"
            Register={register}
            Errors={errors}
          />
          <Input
            {...fieldProps}
            defValue=""
            element="number"
            Label={OrderLanguage.FilterForm.FormLabals.maxPrice.label}
            placeholder={OrderLanguage.FilterForm.FormLabals.maxPrice.placeHolder}
            FieldName="maxPrice"
            Register={register}
            Errors={errors}
          />
          <div className="event-orders-field event-orders-field--search">
            <span className="event-orders-label event-orders-label--hidden" aria-hidden="true">
              Search
            </span>
            <button
              disabled={loading}
              type="submit"
              className="event-orders-search-btn"
            >
              {OrderLanguage.FilterForm.SubmitText}
            </button>
          </div>
        </div>
      </form>
    </MainComponentWrapper>
  );
};

export default OrderFilter;
